import React from 'react';
import UserAvatar from 'treeline-react-core-components/UserAvatar';
import { TimeStamp } from '../UI/TimeStamp';
import { ReviewRating } from '../UI/ReviewRating';
import './userTitleReview.css';
import { Translate } from 'react-localize-redux';

export class UserTitleReview extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			titleName: '',
			reviewText: '',
			rating: 0,
		};
	}

	decodeHtml(html) {
		var txt = document.createElement('textarea');
		txt.innerHTML = html;
		return txt.value;
	}

	render() {
		return (
			<div>
				<div className="clear">
					<div>
						<div id="singleUserSummary" className="clear">
							<div className="column">
								{this.props.userAvatar ? (
									<UserAvatar
										userInitials={
											this.props.userAvatar.initials
										}
										avatarUri={
											this.props.userAvatar.url || null
										}
										displayName={
											this.props.userAvatar.displayName
										}
										avatarSizeClass={`avatar-${
											this.props.userAvatar.size
										}`}
									/>
								) : (
									''
								)}
							</div>
							<div className="userMiddle column-spaced">
								<div className="dotDot">
									<Translate id="submitted_by" />{' '}
									<span className="bold">
										{this.props.userName}
									</span>{' '}
									<TimeStamp
										activityTime={this.props.createdDate}
									/>{' '}
									({this.props.createdDate})
								</div>
								{this.props.orgName !== this.props.userName ? (
									<div className="dotDot">
										{this.props.orgName}
									</div>
								) : null}
								<div className="text-small dotDot">
									{this.props.orgLocation}
								</div>
								{this.props.orgName !== this.props.userName ? (
									<div className="dotDot">
										{this.props.orgName}
									</div>
								) : null}
								<div className="text-small dotDot">
									{this.props.orgLocation}
								</div>
							</div>
							<div className="clear" />
						</div>
						<div className="rating-box">
							<div className="column">
								<Translate id="overall_rating" />:{' '}
							</div>
							<div className="column-spaced">
								<ReviewRating
									rating={this.props.rating}
									size="small"
								/>
							</div>
							<div className="clear" />
						</div>
						<div className="clear text-small pad-top-10">
							{this.props.assessments
								? this.props.assessments.map(
										(assessment, idx) => (
											<div
												key={`assessment-${idx}`}
												className={`column-spaced ${
													assessment.assessmentValue <
														0 ||
													assessment.assessmentID ===
														9
														? 'hidden'
														: ''
												}`}>
												<div className="column">
													{assessment.assessmentName}
													&nbsp;&nbsp;
												</div>
												<div className="column-narrow">
													<ReviewRating
														rating={
															assessment.assessmentValue
														}
														size="x-small"
													/>
												</div>
											</div>
										),
								  )
								: ''}
							<div className="clear" />
						</div>
						<div className="text-medium pad-top-10">
							{this.decodeHtml(this.props.reviewText)}
						</div>
					</div>
				</div>
				<div
					id="sr-themes-container"
					className="clear pad-top-20 hidden">
					<div className="column bold">Themes:</div>
					<div id="sr-themes" className="column" />
					<div className="clear" />
				</div>
			</div>
		);
	}
}
